<template>

    <kt-modal
        :visible="recordVisible"
        :title="recordTitle"
        @dismiss="onDismiss()"
    >
        <template #body>
            <tech-form 
                v-model="record"
            ></tech-form>
        </template>
    
        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-md-10 offset-md-2': record.Id, 'col-md-6 offset-md-6': !record.Id }">
                    <div class="row">
                        <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                            <button @click="onDismiss()" class="btn btn-sm btn-outline-secondary form-control">
                                <X size="16" class="" /> &nbsp;
                                Close
                            </button>
                        </div>
                        <div class="col-4" v-if="record.Id">
                            <button @click="deleteRecord()" class="btn btn-sm btn-outline-danger form-control">
                                <Trash :size="16" class="" /> &nbsp;
                                Delete
                            </button>
                        </div>
                        <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                            <button @click="saveRecord()" class="btn btn-sm btn-outline-primary form-control">
                                <Save :size="16" class="" /> &nbsp;
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </kt-modal>
        
    </template>
    
    <script lang="ts" setup>
    
    import { ref, onMounted, onUpdated, watch } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import Api from "@/services/ApiService";
    import TechForm from "@/components/Techs/TechForm.vue";
    import { TechnicianModel } from "@/models/TechnicianModel";
    import KtModal from "@/components/UI/KtModal.vue";
    import Alert from "@/services/Alert";
    import { useTechStore } from "@/stores/TechStore";
    import { Save, X, Trash } from 'lucide-vue-next';
    
    const route = useRoute();
    const router = useRouter();
    const recordTitle = ref("Tech Entry");
    const recordVisible = ref(true);
    
    const props = defineProps({
        id: {
            type: [Number, String],
            default: null
        }
    });
    
    const emit = defineEmits(["cancel", "saved"]);
    
    const newRecord = () =>
    {
        return new TechnicianModel();
    };
    
    const record = ref(newRecord());
    
    const saveRecord = async () =>
    {
        if (!record.value.TechnicianName)
        {
            Alert.notify({
                text:"Please enter a technician name"
            });
            return;
        }

        if (!record.value.Email)
        {
            Alert.notify({
                text: "Please enter an email address"
            });
            return;
        }

        let pay = record.value;
        await Api.saveTech(pay);

        let techs = useTechStore();
        await techs.reload();

        // If used as global modal, emit event; otherwise navigate
        if (props.id !== null) {
            emit("saved");
        } else {
            router.back();
        }
    };
    
    const deleteRecord = async () =>
    {
        Alert.notify({
            text: "Deletion is currently disabled"
        });
    };
    
    
    const onDismiss = () =>
    {
        // If used as global modal, emit event; otherwise navigate
        if (props.id !== null) {
            emit("cancel");
        } else {
            router.back();
        }
    };

    const loadRecord = async (idValue?: string | number | null) =>
    {
        if (idValue && idValue !== "new") {
            let rec = await Api.loadTech(Number(idValue));
            record.value = rec;
        } else {
            record.value = newRecord();
        }
    };

    
    /*
    onUpdated(async () =>
    {
        loadRecord();
    });
    */

    onMounted(() =>
    {
        // Use prop id if provided, otherwise use route params
        let idToLoad = props.id !== null ? props.id : route.params.id;
        // Handle case where route.params.id might be an array
        if (Array.isArray(idToLoad)) {
            idToLoad = idToLoad[0];
        }
        loadRecord(idToLoad);
    });
    
    // Watch for prop changes when used as global modal
    watch(() => props.id, async (newId) => {
        if (newId !== null) {
            await loadRecord(newId);
        }
    });
    
</script>